const isBuildTime = () => {
  return typeof window === "undefined";
};

export default isBuildTime;
